var map = {
	"./assets/image/sgtest/result/kurisu/role_joy.png": "57a3",
	"./assets/image/sgtest/result/mayuri/role_joy.png": "3692",
	"./assets/image/sgtest/result/rintarou/role_joy.png": "9f61",
	"./assets/image/sgtest/result/suzuha/role_joy.png": "18df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "370e";